import { piniaRequestLanguageMiddleware } from '@/middlewares'
import { useAuthStore } from '@/stores/auth'
import { defineDefaultAPIStoreOptions } from '@rokoli/bnb/drf'
import { merge } from 'es-toolkit/compat'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import polyfills from './polyfills'
import router from './router'
import { configureSentry } from './sentry'
import './tailwind.css'

defineDefaultAPIStoreOptions({ mergeDriver: merge })

const pinia = createPinia()
pinia.use(piniaRequestLanguageMiddleware)

const app = createApp(App)
app.use(pinia)
app.use(router)

async function init() {
  await configureSentry({ app, pinia, router })
  await polyfills()
  app.mount('#app')
  const authStore = useAuthStore()
  void authStore.init()
}

void init()
